import React from "react";
import { Checkbox } from "./ui/checkbox";
import { Card } from "./ui/card";
import { Label } from "./ui/label";
import { formatCurrencyBRL, calculateParcelInfo, getTipoAceiteLabel, getTipoAceiteClass } from "../lib/utils";

export function ProcessCard({
  process,
  isSelected,
  onToggle,
  selectedType = 'acordo',
  onTypeChange,
  showJuri = true,
  showParcelado = true,
  hideCheckbox = false
}) {
  const valorCredito = Number(process.valor_credito || process.valor_proposta_final || 0);
  const valorPropostaFinal = process.valor_proposta_final || 0;
  const valorFgts = process.valor_fgts ? Number(process.valor_fgts) : null;
  const cnj = process.processo?.cnj || process.cnj || "";
  const nomeProcesso = process.processo?.nome_processo || process.nome_processo || "";
  const cessaoBlocked = Boolean(process.processo?.bloquear_cessao ?? process.bloquear_cessao);

  const processoLabel = cnj && nomeProcesso ? `${cnj} - ${nomeProcesso}` : nomeProcesso || cnj || "N/A";

  const installmentText = process.parcelas && process.parcelas > 1
    ? `${formatCurrencyBRL(valorCredito)} em ${process.parcelas} parcelas`
    : formatCurrencyBRL(valorCredito);

  const installmentDetails = calculateParcelInfo(process);

  const isJuriSelected = selectedType === 'acordo_cessao';

  return (
    <Card className={`p-4 border-2 transition-all ${isSelected ? 'border-blue-500 bg-blue-50/50' : 'border-slate-200 hover:border-slate-300'}`}>
      <div className="flex items-start gap-3">
        {!hideCheckbox && (
          <Checkbox
            id={`process-${process.id}`}
            checked={isSelected}
            onCheckedChange={(checked) => onToggle && onToggle(process.id, checked)}
            className="mt-1"
          />
        )}
        <div className="flex-1 space-y-4">
          <div className="flex items-center justify-between">
            <Label htmlFor={`process-${process.id}`} className="text-lg font-semibold text-slate-800 cursor-pointer">
              Processo: {processoLabel}
            </Label>
            <span className={`text-sm font-medium px-2 py-1 rounded-full ${getTipoAceiteClass(process.tipo_aceite)}`}>
              {getTipoAceiteLabel(process.tipo_aceite)}
            </span>
          </div>

          {showJuri && !cessaoBlocked && (
            <div
              className={`p-4 rounded-lg border transition-all cursor-pointer 
                        ${isJuriSelected ? 'bg-emerald-100 border-emerald-500 ring-1 ring-emerald-500' : 'bg-emerald-50 border-emerald-200 hover:bg-emerald-100'}`}
              onClick={() => onTypeChange && onTypeChange(process.id, true)}
            >
              <div className="flex items-center justify-between mb-2">
                <Label className="text-sm font-medium text-emerald-900 cursor-pointer">
                  Proposta Juri (À vista)
                </Label>
                {isJuriSelected && <div className="w-3 h-3 bg-emerald-500 rounded-full" />}
              </div>
              <div className="text-xl font-bold text-emerald-700">
                {formatCurrencyBRL(valorPropostaFinal)}
              </div>
              <p className="text-xs text-emerald-600 mt-1">
                Receba antecipadamente sem devolver valores.
              </p>
            </div>
          )}

          {showJuri && cessaoBlocked && (
            <div className="p-4 rounded-lg border border-amber-300 bg-amber-50">
              <div className="flex items-center justify-between mb-2">
                <Label className="text-sm font-medium text-amber-900 cursor-default">
                  Proposta Juri (À vista)
                </Label>
                <div className="w-3 h-3 bg-amber-500 rounded-full" />
              </div>
              <p className="text-sm font-semibold text-amber-800">
                Cessão de crédito indisponível para este processo.
              </p>
              <p className="text-xs text-amber-700 mt-1">
                Apenas o fluxo do acordo parcelado está habilitado.
              </p>
            </div>
          )}

          {showParcelado && (
            <div
              className={`p-4 rounded-lg border transition-all cursor-pointer
                        ${!isJuriSelected ? 'bg-slate-100 border-slate-500 ring-1 ring-slate-500' : 'bg-slate-50 border-slate-200 hover:bg-slate-100'}`}
              onClick={() => onTypeChange && onTypeChange(process.id, false)}
            >
              <div className="flex items-center justify-between mb-2">
                <Label className="text-sm font-medium text-slate-900 cursor-pointer">
                  Acordo Parcelado
                </Label>
                {!isJuriSelected && <div className="w-3 h-3 bg-slate-500 rounded-full" />}
              </div>
              <div className="text-xl font-bold text-slate-700">
                {installmentText}
              </div>
              <p className="text-xs text-slate-500 mt-1">
                {installmentDetails}
              </p>
              {valorFgts > 0 && (
                <p className="text-sm font-bold text-amber-800 bg-amber-50 border border-amber-300 rounded px-3 py-2 mt-2 leading-snug">
                  {formatCurrencyBRL(valorFgts)} a serem pagos em conta vinculada a título de FGTS
                </p>
              )}
              {cessaoBlocked && (
                <p className="text-xs font-semibold text-amber-800 bg-amber-50 border border-amber-300 rounded px-3 py-2 mt-2 leading-snug">
                  A cessão de crédito está bloqueada para este processo.
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}
